module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    staticStyle: {
      "margin-top": "7em"
    },
    attrs: {
      "id": "prompt-forum",
      "tabindex": "-10",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "border-radius": "3px"
    }
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "i-trending"
  }, [(_vm.forums && (Object.keys(_vm.forums).length > 0)) ? _c('div', {
    staticStyle: {
      "padding": "1em",
      "line-height": "1.8"
    }
  }, [_c('span', {
    staticClass: "center",
    staticStyle: {
      "background": "#22baae",
      "margin-top": "-1.2em",
      "margin-left": "18vw",
      "text-align": "center",
      "padding": "0.3em",
      "color": "#ffffff"
    }
  }, [_vm._v("Trending")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'forum?topic=' + _vm.forums[0].forum_topic_url
    }
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [(_vm.forums[0].forum_comments.length) ? _c('span', {
    staticClass: "badge",
    staticStyle: {
      "background-color": "#22baae"
    }
  }, [_vm._v(_vm._s(_vm.forums[0].forum_comments.length))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333",
      "font-size": "18px"
    }
  }, [_c('i', [_vm._v("...\"" + _vm._s(_vm.forums[0].forum_topic) + "\"...")])])])])]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_vm._v("Join Discussions")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-block m-t-xs",
    attrs: {
      "href": "https://cityneeds.ng/forums"
    }
  }, [_vm._v("Start a Discussion")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "28px",
      "line-height": "1.4",
      "color": "#000000"
    }
  }, [_vm._v("So many "), _c('span', [_vm._v("discussions")]), _vm._v(" are going on..")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67f2fe40"}!./src/components/YPrompts/template.html
// module id = 299
// module chunks = 0